export default __webpack_public_path__ + "static/media/LogoDTec.3a088ca3.svg";